var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* Interlucent streaming */
import InterlucentPlayer from '../interlucent/InterlucentPlayer';
import { useStream } from '../interlucent/StreamContext';
import { useStreamCompat } from '../interlucent/useStreamCompat';
import { StreamerStatus } from '../interlucent/streamerStatus';
/* External libraries */
import { Routes, Route, useNavigate } from 'react-router-dom';
import { isMobile, osName, isMacOs } from 'react-device-detect';
import React, { useEffect, useState, useRef } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
/* Styles */
import '../styles/App.css';
import '../styles/style.css';
/* Datas */
import * as Filters from '../datas/constants';
/* Components */
import StartModal from './StartModal';
import Footer from './common/Footer';
import Loader from './Loader';
import PopUp from './scene/PopUp';
import Joystick from './ui/Joystick';
import ProductLabel from './scene/ProductLabel';
import Hotspots from './intro/Hotspots';
import EndSessionPage from './EndSessionPage';
import useElementSize from "./useElementSize";
import SceneSidebar from './scene/SceneSidebar';
import PreparingOverlay from './PreparingOverlay';
import IdleTimeout from './common/IdleTimeout';
import { useHotspot, HotspotProvider } from './context/HotspotContext';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { AppStateProvider, useAppState } from './context/AppStateContext';
import logger from '../Log';
/* Hooks */
import { useAnalytics } from '../hooks/useAnalytics';
import { useSessionTimer } from '../hooks/useSessionTimer';
import { useUnityMessages } from '../hooks/useUnityMessages';
import HomeHeader from './common/HomeHeader';
import IdleOverlayHint from './common/IdleOverlayHint';
var anonymize = require('ip-anonymize');
var EmbeddedView = function (props) {
    var handle = useFullScreenHandle();
    var _a = useElementSize(), bodyRef = _a[0], _b = _a[1], width = _b.width, height = _b.height;
    var _c = useState(width > height), isLandscape = _c[0], setIsLandscape = _c[1];
    var _d = useState(false), switchChecked = _d[0], setSwitchChecked = _d[1];
    var _e = useAppState(), setWithSound = _e.setWithSound, isScene = _e.isScene;
    var sendMessage = useStream().sendMessage;
    var canSend = props.StreamerStatus === StreamerStatus.Connected;
    var sendIfConnected = function (name, param1, param2) {
        if (param1 === void 0) { param1 = null; }
        if (param2 === void 0) { param2 = null; }
        console.log("############### ENVOI A UNITY : " + name + " - " + param1 + " - " + param2);
        if (canSend)
            sendMessageToGame(name, param1, param2);
    };
    var handleSwitchHeating = function () {
        var heatingSystem = switchChecked ? 0 : 1;
        sendIfConnected("SwitchHeating", heatingSystem);
        setSwitchChecked(!switchChecked);
    };
    var handleGoPacs = function () {
        if (switchChecked) {
            sendIfConnected("SwitchHeating", 0);
            setSwitchChecked(false);
        }
    };
    var goIntroScene = function () { return sendIfConnected("ChangeScene", "Intro"); };
    var firstCallSwitchHeatingSystem = function () {
        if (switchChecked)
            sendIfConnected("SwitchHeating", 1);
        if (isMobile)
            sendIfConnected("TouchDevice");
    };
    var selectAllNetworks = function () { return sendIfConnected("ResetNetworks"); };
    var selectNetworkById = function (networkId) { return sendIfConnected("SelectNetwork", String(networkId)); };
    var outlineNetwork = function (networkId) { return sendIfConnected("OutlineNetwork", String(networkId)); };
    var clearOutlineNetwork = function (networkId) { return sendIfConnected("ClearOutlineNetwork", String(networkId)); };
    var changeViewTarget = function (targetId) { return sendIfConnected("ChangeView", null, [targetId]); };
    var startMove = function (direction) { return sendIfConnected("StartMove", direction); };
    var stopMove = function (direction) { return sendIfConnected("EndMove", direction); };
    var crouchGetUp = function () { return sendIfConnected("CrouchGetUp"); };
    var uncrouchPlayer = function () { return sendIfConnected("UncrouchPlayer"); };
    var unlockPlayer = function () { sendIfConnected("UnlockPlayer"); console.log("unlockPlayer called"); };
    var lockPlayer = function () { return sendIfConnected("LockPlayer"); };
    var changeScene = function (sceneName) { return sendIfConnected("ChangeScene", sceneName); };
    var outlineObj = function (objName, layer) { return sendIfConnected("OutlineObj", objName, [layer]); };
    var cuveEmptying = function () { return sendIfConnected("ChangeView", null, ["target_cuve_emptying"]); };
    var cuveFilling = function () { return sendIfConnected("ChangeView", null, ["target_cuve_filling"]); };
    function enableSound() {
        setWithSound(true);
        sendIfConnected("EnableAudio");
    }
    function disableSound() {
        setWithSound(false);
        sendIfConnected("DisableAudio");
    }
    function UnityInitialUpdate() {
        if (isMobile)
            sendMessageToGame("TouchDevice", null, null);
    }
    useEffect(function () {
        if (props.StreamerStatus === StreamerStatus.Connected) {
            setTimeout(function () {
                sendMessageToGame("GoToFloor", null, [2]);
            }, 2000);
        }
    }, [props.StreamerStatus]);
    function sendMessageToGame(functionName, objName, parameters) {
        //create a message
        var message = { type: 'message', functionName: functionName, objName: objName, parameters: parameters };
        //send a message to Unity
        sendMessage(message);
    }
    useEffect(function () {
        if (props.InitialUpdate === true) {
            UnityInitialUpdate();
        }
    }, [props.InitialUpdate]);
    useEffect(function () {
        if (width < height)
            setIsLandscape(false);
        else
            setIsLandscape(true);
    }, [width, height]);
    var wheel = function (e) {
        console.log(e.deltaY);
        if (!isMacOs /*|| (e.deltaY < 0 && e.deltaY > -100) || (e.deltaY > 0 && e.deltaY < 100)*/) {
            sendMessageToGame("Wheel", null, [-e.deltaY * 100]);
            console.log(-e.deltaY * 100);
        }
        else {
            var value = 0;
            if (-e.deltaY < 0)
                value = -20;
            else
                value = 20;
            console.log(value);
            sendMessageToGame("Wheel", null, [value * 20]);
        }
    };
    return (_jsx("div", __assign({ style: { width: '100%', height: '100%' }, ref: bodyRef, onWheel: wheel }, { children: _jsxs(FullScreen, __assign({ handle: handle }, { children: [_jsx(IdleTimeout, { Status: props.StreamerStatus, WarningThreshold: 300, ExitThreshold: 120, WarningCallback: handle.exit, ExitCallback: function () { return window.location.reload(); } }), _jsx(Joystick, { isMobile: isMobile, isLandscape: isLandscape, startMoveFunction: startMove, endMoveFunction: stopMove, streamerStatus: props.StreamerStatus }), _jsx(IdleOverlayHint, {}), _jsx(HomeHeader, { subsidiary: props.Subsidiary, showNavigationInstructions: props.ShowNavigation, goIntroScene: goIntroScene, enableSound: enableSound, disableSound: disableSound }), isScene && (_jsx(SceneSidebar
                // callbacks Unity
                , { 
                    // callbacks Unity
                    onNavigateUp: function () { return changeViewTarget("floor2"); }, onNavigateDown: function () { return changeViewTarget("floor1"); }, onSelectAllNetworks: selectAllNetworks, onSelectNetwork: selectNetworkById, onPlayAnimationA: function () { return cuveEmptying(); }, onPlayAnimationB: function () { return cuveFilling(); }, onHoverNetwork: outlineNetwork, onLeaveNetwork: clearOutlineNetwork })), _jsx(Hotspots, { changeScene: changeScene }), _jsx(PopUp, { uncrouchPlayer: uncrouchPlayer, subsidiaryForTexts: props.SubsidiaryForTexts, lockPlayer: lockPlayer, unlockPlayer: unlockPlayer, outlineObj: outlineObj }), _jsx(ProductLabel, { IsVisible: props.LabelVisible, SubsidiaryForTexts: props.SubsidiaryForTexts }), _jsx(Footer, { isMobile: isMobile, isShown: props.StreamerStatus })] })) })));
};
var isBrowserSupported = function () {
    return typeof window !== 'undefined' &&
        typeof RTCPeerConnection !== 'undefined' &&
        !!navigator.mediaDevices;
};
var App = function () {
    var _a = useAppState(), sceneState = _a.sceneState, setSceneState = _a.setSceneState, setIsScene = _a.setIsScene, setProductName = _a.setProductName, setHoveredProductName = _a.setHoveredProductName, setLabelPosition = _a.setLabelPosition, setVideoLoader = _a.setVideoLoader, setProductNameMulti = _a.setProductNameMulti;
    var _b = useLanguage(), language = _b.language, setLanguage = _b.setLanguage, setIsMultilingual = _b.setIsMultilingual;
    // Heating system
    var _c = useState(false), initialUpdate = _c[0], setInitialUpdate = _c[1];
    var _d = useState(""), subsidiaryForTexts = _d[0], setSubsidiaryForTexts = _d[1];
    var navigate = useNavigate();
    function showNavigation() {
        window.dispatchEvent(new Event("tutorial:force-open"));
    }
    // Filtering
    var _e = useState(Filters.Filter.ALL), selectedFilter = _e[0], setSelectedFilter = _e[1];
    // Analytics
    var subsidiary = useRef("");
    var os = useRef("");
    var _f = useAnalytics(), trackProduct = _f.trackProduct, trackLanguage = _f.trackLanguage, saveAnalytics = _f.saveAnalytics, setOS = _f.setOS, setSubsidiary = _f.setSubsidiary, products = _f.products, languages = _f.languages, productsSubsidiary = _f.productsSubsidiary, internalTraffic = _f.internalTraffic, statusRef = _f.statusRef;
    var _g = useSessionTimer(), start = _g.start, getDuration = _g.getDuration;
    var _h = useState(false), showLabelProduct = _h[0], setShowLabelProduct = _h[1];
    var _j = useState(), hotspotPosition = _j[0], setHotspotPosition = _j[1];
    var _k = useHotspot(), updateHotspot = _k.updateHotspot, resetHotspots = _k.resetHotspots;
    var _l = useState(""), lastButtonOutline = _l[0], setLastButtonOutline = _l[1];
    function getIP() {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch('https://api.ipify.org/?format=json')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    }
    function checkInternalTraffic(ip) {
        var ipAddress = anonymize(ip);
        var internalRanges = [
            "176.176.79.0", "10.68.0.0", "10.68.1.0", "10.68.2.0", "10.68.3.0",
            "10.21.68.0", "10.21.69.0", "10.21.70.0", "10.21.71.0",
            "10.25.68.0", "192.168.34.0", "192.168.30.0", "192.168.100.0",
            "192.168.50.0", "192.168.51.0", "192.168.10.0", "10.68.69.0",
            "10.38.69.0", "10.68.89.0", "10.51.74.0", "10.28.90.0",
            "10.68.29.0", "10.51.72.0", "10.26.2.0", "10.26.1.0",
            "10.68.200.0", "10.18.0.0", "10.18.2.0"
        ];
        if (internalRanges.includes(ipAddress)) {
            internalTraffic.current = true;
        }
    }
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var domainName, source, queryParameters, lang;
        return __generator(this, function (_a) {
            getIP()
                .then(function (data) { return checkInternalTraffic(data.ip); })
                .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                }
                else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
            domainName = window.location.hostname;
            source = "";
            if (domainName.includes('produitsvirtuels.sferaco.com')) {
                source = 'sferaco';
                setSubsidiaryForTexts("sf_se");
                setLanguage("fr");
            }
            else if (domainName.includes('produitsvirtuels.sectoriel.com')) {
                source = 'sectoriel';
                setSubsidiaryForTexts("sf_se");
                setLanguage("fr");
            }
            else if (domainName.includes('produitsvirtuels.syveco.com')) {
                source = 'syveco';
                setSubsidiaryForTexts("sy");
                setLanguage("en");
                setIsMultilingual(true);
            }
            else if (domainName.includes('produitsvirtuels.thermador-groupe.fr')) {
                source = 'thg';
                setSubsidiaryForTexts("sf_se");
                setIsMultilingual(true);
                setLanguage("fr");
            }
            else {
                source = "sferaco";
                setSubsidiaryForTexts("sf_se");
                setLanguage("fr");
                setIsMultilingual(false);
            }
            subsidiary.current = source;
            queryParameters = new URLSearchParams(window.location.search);
            lang = queryParameters.get("lang");
            if (lang !== null && (subsidiary.current === "thg" || subsidiary.current === "syveco"))
                setLanguage(lang);
            setOS(osName);
            setSubsidiary(subsidiary.current);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getData();
    }, []);
    var _m = useStream(), streamStatus = _m.status, message = _m.message, sendMessage = _m.sendMessage, connect = _m.connect;
    var streamerStatus = useStreamCompat();
    var _o = useState(false), loading = _o[0], setLoading = _o[1];
    var launch = function () {
        setLoading(true);
        connect();
    };
    var showEndSessionPage = function () {
        launch();
        setTimeout(function () {
            saveAnalytics();
            navigate('/reload?type=endSession&lang=' + language);
        }, 480000); // 8 min = 480000 ms - 30 min = 1800000 ms
    };
    var startStream = function () {
        setVideoLoader(true);
        showEndSessionPage();
    };
    function createProductsSubsidiaryMap(path) {
        fetch(path, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            // initialize productsSubsidiary
            Object.keys(data).map(function (key) {
                return productsSubsidiary.current.push({ product: key, filiale: data[key] });
            });
        });
    }
    useEffect(function () {
        if (sceneState === "CuveAlcool" || sceneState === "CuveReacteur")
            showNavigation();
    }, [sceneState]);
    // Les marqueurs de hotspot (SendItemPosition côté Unity) existent dans chaque
    // scène de contenu et envoient leur position en continu depuis LEUR propre
    // caméra. Sans ce reset, revenir sur une scène affiche d'abord les dernières
    // coordonnées reçues de la scène précédente (mauvais point de vue caméra)
    // pendant les ~2-3s que Unity met à renvoyer une position fraîche pour la
    // scène qu'on vient de charger.
    useEffect(function () {
        resetHotspots();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sceneState]);
    useEffect(function () {
        trackLanguage(language);
        if (subsidiary.current === "thg") {
            if (language === "fr")
                setSubsidiaryForTexts("sf_se");
            if (language === "en")
                setSubsidiaryForTexts("sy");
        }
    }, [language]);
    useEffect(function () {
        createProductsSubsidiaryMap("./Ressources/products_subsidiary_map.json");
    }, []);
    // Log status messages
    useEffect(function () {
        logger.info('Status', streamStatus, streamerStatus);
        statusRef.current = streamerStatus;
        if (streamerStatus === StreamerStatus.Connected) {
            start(); // démarre le timer
        }
        var hasEnded = [
            StreamerStatus.Failed,
            StreamerStatus.NotSupported,
            StreamerStatus.Disconnected,
            StreamerStatus.Withdrawn,
            StreamerStatus.Closed,
        ].includes(streamerStatus);
        if (hasEnded) {
            saveAnalytics();
        }
    }, [streamStatus, streamerStatus]);
    // Subscribe to game messages
    useUnityMessages(message, {
        sceneState: sceneState,
        setSceneState: setSceneState,
        setIsScene: setIsScene,
        setInitialUpdate: setInitialUpdate,
        setProductName: setProductName,
        setProductNameMulti: setProductNameMulti,
        setHoveredProductName: setHoveredProductName,
        setShowLabelProduct: setShowLabelProduct,
        setLabelPosition: setLabelPosition,
        updateHotspot: updateHotspot,
        setLastButtonOutline: setLastButtonOutline,
        setSelectedFilter: setSelectedFilter,
        trackProduct: trackProduct,
    });
    useEffect(function () {
        var handleBeforeUnload = function () {
            if (statusRef.current === StreamerStatus.Connected)
                saveAnalytics();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Begin connection
    if (streamerStatus === StreamerStatus.Disconnected) {
        window.location.assign('./reload.html?type=reload&lang=' + language);
    }
    if (streamerStatus === StreamerStatus.Failed) {
        window.location.assign('./reload.html?type=reload&lang=' + language);
    }
    if (streamerStatus === StreamerStatus.Withdrawn) {
        window.location.assign('./reload.html?type=reload&lang=' + language);
    }
    var content;
    if (loading && !(streamerStatus === StreamerStatus.Connected || streamerStatus === StreamerStatus.Completed)) {
        content = (_jsx("div", __assign({ style: {
                position: 'relative',
                backgroundColor: '#000',
                height: '100%',
                width: '100%',
                overflow: 'hidden'
            } }, { children: _jsx(PreparingOverlay, { dimBackground: false, isFirstLoading: false }) })));
    }
    else if (loading) {
        content = (_jsx(EmbeddedView, { StreamerStatus: streamerStatus, LabelVisible: showLabelProduct, LastOutlinedButton: lastButtonOutline, ShowNavigation: showNavigation, SelectedFilter: selectedFilter, InitialUpdate: initialUpdate, SubsidiaryForTexts: subsidiaryForTexts, Subsidiary: subsidiary.current, onClose: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setLoading(false);
                    return [2 /*return*/];
                });
            }); } }));
    }
    else if (streamerStatus === StreamerStatus.NotSupported) {
        window.location.assign("./reload.html?type=changeNavigator&lang=" + language);
        content = null;
    }
    else if (streamerStatus === StreamerStatus.Failed) {
        window.location.assign("./reload.html?type=reload&lang=" + language);
        content = null;
    }
    else {
        content = (_jsxs("div", __assign({ id: "launchContainer", style: {
                background: 'white',
                height: '100%',
                width: '100%'
            } }, { children: [_jsx(Loader, { isMobile: isMobile, subsidiary: subsidiary.current }), _jsx(StartModal, { startStream: startStream, language: language })] })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(InterlucentPlayer, {}), content] }));
};
var AppWrapper = function () {
    return isBrowserSupported() ? (_jsx(LanguageProvider, { children: _jsx(HotspotProvider, { children: _jsx(AppStateProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(App, {}) }), _jsx(Route, { path: "/reload", element: _jsx(EndSessionPage, {}) })] }) }) }) })) : (_jsx("div", __assign({ className: "ui red segment center aligned basic" }, { children: _jsx("h2", __assign({ className: "header" }, { children: "Votre navigateur n'est actuellement pas support\u00E9 pour cette exp\u00E9rience." })) })));
};
export default AppWrapper;
